import styled from 'styled-components'
import { PaletteNames, themeColor, themeFontFamily, IconComponent } from 'LibNeo'

interface StatusProps {
	color: PaletteNames | 'violet' | 'magenta'
	isRounded: boolean
	isForm: boolean
	title: string | null
}

const getColor = (color) => {
	switch (color) {
		case 'violet':
			return themeColor('violet')
		case 'magenta':
			return themeColor('white')
		default:
			return themeColor(color, 6)
	}
}

export const Status = styled.span<StatusProps>`
	display: inline-flex;
	justify-content: flex-start;
	align-items: center;
	padding: ${({ isForm, title }) => {
		if (!title) {
			return '4px'
		}
		if (isForm) {
			return '0'
		}
		return '0 6px'
	}};
	border-radius: ${({ isRounded }) => (isRounded ? '10px' : '4px')};
	background-color: ${({ color, isForm }) => {
		if (isForm) return 'initial'
		switch (color) {
			case 'violet':
				return themeColor('gray', 1)
			case 'magenta':
				return themeColor(color)
			default:
				return themeColor(color, 1)
		}
	}};
	color: ${({ color, isForm }) => {
		if (isForm && color === 'magenta') return themeColor(color)
		return getColor(color)
	}};
`

export const StatusIcon = styled.span<Partial<StatusProps>>`
	width: 12px;
	height: 12px;
	margin-right: ${({ isForm, title }) => (isForm && !title ? '0' : '2px')};
`

export const StatusTitle = styled.span`
	font-family: ${themeFontFamily('SBSansText')};
	font-weight: 400;
	font-size: 12px;
	line-height: 20px;
`

export const Icon = styled(IconComponent)<{ color: PaletteNames | 'violet' | 'magenta' }>`
	width: 12px;
	height: 12px;
	vertical-align: top;
	svg {
		width: 12px;
		height: 12px;
		vertical-align: top;
		fill: ${({ color }) => getColor(color)};
	}
`
